import { render, staticRenderFns } from "./MobileAppHero.vue?vue&type=template&id=f89c7b42&"
import script from "./MobileAppHero.vue?vue&type=script&lang=js&"
export * from "./MobileAppHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports